export default {
  public: {
    loading: "Carregando...",
    ok: "OK",
    cancel: "Cancelar",
    back: "Voltar",
    userDefined: "Personalizado",
    edit: "Editar",
    clear: "Limpar",
    delete: "Excluir",
    close: "Fechar",
    remove: "Remover",
    preView: "Visualizar",
    replace: "Substituir",
    systemMsg: "Informação",
    generateSuccess: "Sua apresentação do PowerPoint foi gerada com sucesso!",
    templateChoose: "Escolha um modelo para concluir sua própria criação de IA",
    templateChooseShort: "Escolher um modelo",
    templateChangeTips:
      "A substituição dos dados do modelo restaurará seu conteúdo original. O conteúdo modificado será perdido. Tem certeza de que deseja continuar?",
    sourceInvalid: "A fonte de dados é inválida, por favor, tente novamente.",
    systemBusy: "O servidor está ocupado, por favor, atualize a página.",
    templateReplaceSuccess:
      "A substituição do modelo foi bem-sucedida. Por favor, salve manualmente, pois o sistema não salvará automaticamente.",
    shareLinkTips: "Cópia bem-sucedida! Redirecionando página da web agora!",
    noPermissionTips:
      "Desculpe, a permissão de compartilhamento deste ppt foi fechada pelo autor~ Você pode fazer login no aippttv, mostrar sua imaginação e criar seu próprio ppt!",
    copyTips: "Cópia bem-sucedida!",
    loginTips: "Por favor, faça login primeiro!",
    bottomTag: "Feito com {brand}",
    fontType: {
      Arial: "Arial",
      "Microsoft Yahei": "Microsoft YaHei",
      SimSun: "SimSun",
      SimHei: "SimHei",
      KaiTi: "KaiTi",
      NSimSun: "NSimSun",
      FangSong: "FangSong",
      "PingFang SC": "PingFang",
      STHeiti: "STHeiti",
      STKaiti: "STKaiti",
      STSong: "STSong",
      STFangSong: "STFangsong",
      STZhongSong: "STZhongsong",
      STHupo: "STHupo",
      STXinwei: "STXinwei",
      STLiti: "STLiti",
      STXingkai: "STXingkai",
      "Hiragino Sans GB": "Hiragino Sans",
      "Lantinghei SC": "Lantinghei",
      "Hanzipen SC": "Pianpian",
      "Hannotate SC": "Shouzhati",
      "Songti SC": "Songti",
      "Wawati SC": "Wawati",
      "Xingkai SC": "Xingkai",
      "Yuanti SC": "Yuanti",
      STXihei: "STXihei",
      YouYuan: "Youyuan",
      LiSu: "Lishu",
    },
    font: {
      font: "Fonte",
      sysFont: "Fonte do Sistema",
      lineFont: "Fonte Online",
      fontColor: "Cor do Texto",
      textColor: "Cor da Fonte",
      fontDelay: "Realce de Fonte",
      addSize: "Aumentar Tamanho da Fonte",
      duceSize: "Diminuir Tamanho da Fonte",
      left: "Alinhar à Esquerda",
      middle: "Centro",
      horizontalCenter: "Centro Horizontal",
      verticalCenter: "Centro Vertical",
      right: "Alinhar à Direita",
      bottom: "Alinhar Inferior",
      top: "Alinhar Superior",
      bold: "Negrito",
      em: "Itálico",
      underline: "Sublinhado",
      strikethrough: "Riscado",
      richText: "Limpar Formatação",
      textFormat: "Pincel de Formatação",
      addIndex: "Aumentar Recuo",
      duceIndex: "Diminuir Recuo",
      no: "Numeração",
      link: "Hiperlink",
      inputLink: "Inserir Hiperlink",
      superscript: "Sobrescrito",
      subscript: "Subscrito",
      code: "Código em Linha",
      blockquote: "Citação",
      horizontal: "Horizontal",
      vertical: "Vertical",
      width: "Largura",
      height: "Altura",
      rotate: "Rotacionar",
      uniformHorizontal: "Distribuir Horizontalmente",
      uniformVertical: "Distribuir Verticalmente",
      combine: "Combinar",
      unCombine: "Desagrupar",
      bgColor: "Cor de Fundo",
      mainColor: "Cor do Tema",
      useMainToAll: "Aplicar Tema a Todos",
      preMain: "Tema Pré-definido",
    },
    specialEffects: {
      useAll: "Aplicar a Todos",
      no: "Nenhum",
      fade: "Desvanecer",
      slideX: "Deslizar Esquerda/Direita",
      slideY: "Deslizar Cima/Baixo",
    },
  },
  chart: {
    insertCol: "Inserir Coluna",
    insertRow: "Inserir Linha",
    delCol: "Excluir Coluna",
    delRow: "Excluir Linha",
    merCell: "Mesclar células",
    unMerCell: "Desfazer mesclagem",
    selectCurrentCol: "Selecionar coluna atual",
    selectCurrentRow: "Selecionar linha atual",
    selectAll: "Selecionar todas as células",
    toTheLeft: "Para a esquerda",
    toTheRight: "Para a direita",
    toTheTop: "Para cima",
    toTheBottom: "Para baixo",
  },  
  desktop: {
    fileExportSuccess:
      "O arquivo foi exportado com sucesso. Selecione um local para salvar o arquivo",
    unSupportPreviewPDF: "A visualização de PDF não é suportada no momento",
  },
  extension: {
    nonsupportDownloadPDF:
      "A pré-visualização do PDF não está disponível aqui. Se quiser uma antevisão, aceda ao site oficial do PC.",
  },
  index: {
    createText: "Gerando Conteúdo do PPT",
    createPage: "Gerando Conteúdo para a Página {0}",
    haveProblem: "Estou com um problema",
    systemError: "{0}",
    saveText: "Salvo com sucesso",
    saveMessage: "Tem certeza de que deseja salvar?",
    cBtn: "Cancelar",
    sBtn: "OK",
    waitMsg:
      "Por favor, seja paciente e aguarde de 30 a 40 segundos. Se não gerar, atualize seu navegador e tente novamente!",
  },
  errorCode: {
    "401": "Falha na autenticação, impossível acessar recursos do sistema",
    "403": "Operação atual não permitida",
    "404": "Recurso não encontrado",
    default:
      "Erro de sistema desconhecido, por favor, informe ao administrador",
    notReDo: "Dados estão sendo processados, por favor, não envie novamente.",
    loginMsg: "Sessão inválida ou expirada. Por favor, faça login novamente.",
    errMsg: "Sistema ocupado, por favor, tente novamente mais tarde.",
  },
  linkHandler: {
    pptPage: "Página do Slide",
    change: "Alterar",
    remove: "Remover",
  },
  editor: {
    ctrlV: "Colar",
    ctrlA: "Selecionar Tudo",
    enter: "Nova Página",
    f5: "Apresentação de Slides",
    delete: "Excluir Página",
    ctrlD: "Duplicar Página",
    ctrlX: "Recortar",
    ctrlC: "Copiar",
    shiftF5: "Iniciar da Página Atual",
    positionPanel: {
      horizontalCenter: "Centralizar horizontalmente",
      verticalCenter: "Centralizar verticalmente",
      horizontalVerticalCenter: "Centralizar horizontal e verticalmente",
      left: "Alinhar à esquerda",
      right: "Alinhar à direita",
      top: "Alinhar no topo",
      bottom: "Alinhar na base",
      onTop: "Colocar em cima",
      onBottom: "Colocar embaixo",
      levelUp: "Mover um nível para cima",
      levelDown: "Mover um nível para baixo",
      setLink: "Definir link",
      ungroup: "Desagrupar",
      group: "Agrupar",
      selectAll: "Selecionar tudo",
      lock: "Trancar",
      unlock: "Desbloquear",
      delete: "Excluir",
    },
    canvas: {
      index: {
        ctrlR: "Régua",
        ctrlW: "Linhas de Grade",
        nl: "Nenhum",
        small: "Pequeno",
        middle: "Médio",
        big: "Grande",
        closePan: "Fechar Painel de Seleção",
        openPan: "Abrir Painel de Seleção",
        reCurrentPage: "Redefinir Página Atual",
        showPpt: "Apresentação de Slides",
        generate:'Gerando...'
      },
      linkDialog: {
        url: "Por favor, insira o endereço do link da web",
        ppt: "Slide",
        preView: "Visualização",
        pageUrl: "Link da Web",
        pptPage: "Página do Slide",
      },
    },
    canvasTool: {
      index: {
        ctrlZ: "Desfazer",
        reSet: "Refazer",
        text: "Inserir Texto",
        horizontal: "Caixa de Texto Horizontal",
        vertical: "Caixa de Texto Vertical",
        image: "Inserir Imagem",
        shape: "Inserir Forma",
        line: "Inserir Linha",
        chart: "Inserir Gráfico",
        table: "Inserir Tabela",
        gs: "Inserir Fórmula",
        voice: "Inserir Áudio/Vídeo",
        screen: "Ajustar à Tela",
        workspase: "Espaço de Trabalho",
        save: "Salvar",
        logo: "Inserir Logotipo",
        close: "Fechar PPT",
        share: "Compartilhar",
        download: "Download",
        templateReplacement: "Substituição de Modelo",
      },
      mediaInput: {
        videoUrl: "Digite o URL do Vídeo, por exemplo, https://xxx.mp4",
        voiceUrl: "Digite o URL do Áudio, por exemplo, https://xxx.mp3",
        video: "Vídeo",
        voice: "Áudio",
        videoError: "Por favor, insira primeiro um URL de vídeo correto",
        voiceError: "Por favor, insira primeiro um URL de áudio correto",
      },
      tableGenerator: {
        table: "Tabela",
        row: "Linhas",
        column: "Colunas",
        rcError: "Linhas/Colunas devem estar entre 0 e 20!",
      },
      logo: {
        text1: "Carregar Logotipo da Empresa",
        text2: "Digite o nome da empresa",
        companyNamePlaceholder: "digite o nome da sua empresa",
        single: "Aplicação de página única",
        all: "Aplicação de todas as páginas",
        position: "posição",
      },
    },
    editorHeader: {
      index: {
        file: "Arquivo",
        importPptistFile: "Importar Arquivo pptist",
        importPptxFile: "Importar Arquivo pptx",
        exportPptxFile: "Exportar Arquivo",
        undo: "Desfazer",
        redo: "Refazer",
        createSlide: "Adicionar Página",
        deleteSlide: "Excluir Página",
        closeGridLines: "Fechar Linhas de Grade",
        openGridLines: "Abrir Linhas de Grade",
        closeRuler: "Fechar Régua",
        openRuler: "Abrir Régua",
        resetSlides: "Redefinir Páginas",
        closeSelectPanel: "Fechar Painel de Seleção",
        openSelectPanel: "Abrir Painel de Seleção",
        f5: "Apresentar",
        enterScreeningFromStart: "Iniciar do Início",
        enterScreening: "Iniciar da Página Atual",
        help: "Ajuda",
        hotkey: "Atalhos",
        pptShow: "Apresentação de Slides",
        export: "Exportar",
        importing: "Importando...",
        continue: "Continuar",
        pauseGeneration: "Pausar",
        noPricing:
          "Torne-se um membro e aproveite os privilégios de download conosco.",
        noPricingToOpt: "Desbloqueie todos os privilégios.",
        getTokens: "Atualizar para Pro",
        pptSlidesMsg: "Parabéns por criar {0} slides completos de PPT!",
        Feedback: "Deixe a IA ser sua assistente de trabalho.",
        giveAway: "Distribuir cupons (válidos por 30 minutos)",
        getItNow: "Obtenha agora",
        unlockAllPpt: "Desbloquear todos os recursos do PPT",
        grantPermission: "Conceder permissão para usar o mapa mental da IA",
        grantPermissionToUseGpt: "Conceder permissão para usar o GPT",
        permissionCodeUse:
          "Por favor, lembre-se do código de desconto e prossiga para a página de pagamento para utilizá-lo!",
        pptTi1:
          "Você concluiu todo o trabalho e gerou um total de {0} páginas de PPT.",
        pptTi2:
          "Você só precisa do último passo para ter sua maravilhosa criação de IA!",
      },
    },
    exportDialog: {
      tips:'O download do PPT não é compatível com o aplicativo no momento; faça o download no PC',
      exportScope: "Escopo de Exportação",
      close: "Fechar",
      all: "Todos",
      thisPage: "Atual",
      auto: "Personalizado",
      autoScope: "Intervalo Personalizado",
      exporting: "Exportando...",
      exportImg: "Exportar Imagem",
      expPdf: "Imprimir / Exportar PDF",
      expPptx: "Exportar PPTX",
      downloadSuccess:
        "Conversão de arquivo bem-sucedida. Por favor, selecione um caminho de salvamento",
      exportImage: {
        exportType: "Formato de Exportação",
        imageQuality: "Qualidade da Imagem",
        ignoreFont: "Ignorar Fontes Online",
        ignoreLineFont:
          "Por padrão, as fontes online serão ignoradas durante a exportação. Se você usou fontes online na apresentação e deseja manter seus estilos após a exportação, pode optar por desativar a opção 'Ignorar Fontes Online', mas observe que isso pode aumentar o tempo de exportação.",
      },
      exportPdf: {
        all: "Todos os Slides",
        thisPage: "Slide Atual",
        pageNum: "Páginas por Folha",
        white: "Margem",
        notice:
          "Nota: Se a visualização de impressão não corresponder ao estilo real, verifique a opção 'Gráficos de Fundo' na janela de impressão pop-up.",
      },
      exportPPTX: {
        title: "Substituir Modelo Padrão",
        notice:
          "Nota: Após o download, abra-o com o Microsoft Office, pois outros programas podem não ser compatíveis.",
      },
    },
    remark: {
      remark: "Clique para abrir as notas do apresentador",
    },
    thumbnails: {
      add: "Adicionar Slide",
      slide: "Slide",
    },
    toolbar: {
      common: {
        elementColorMask: {
          recolor: "Recolorar (Máscara)",
          maskColor: "Cor da Máscara",
          opacity: "Opacidade",
        },
        elementFilter: {
          enableFilter: "Ativar Filtros",
          blur: "Desfoque",
          brightness: "Brilho",
          contrast: "Contraste",
          grayscale: "Escala de Cinza",
          saturate: "Saturação",
          hueRotate: "Rotação de Matiz",
          opacity: "Opacidade",
        },
        elementFlip: {
          horizontal: "Virar Horizontalmente",
          vertical: "Virar Verticalmente",
        },
        elementOpacity: {
          opacity: "Opacidade",
        },
        elementOutline: {
          border: "Ativar Borda",
          borderStyle: "Estilo da Borda",
          solid: "Borda Sólida",
          dashes: "Borda Tracejada",
          borderColor: "Cor da Borda",
          borderWeight: "Espessura da Borda",
        },
        elementShadow: {
          enable: "Ativar Sombra",
          horizontal: "Sombra Horizontal",
          vertical: "Sombra Vertical",
          fuzzyDistance: "Distância de Desfoque",
          color: "Cor da Sombra",
        },
      },
      panel: {
        background: "Preenchimento de Fundo",
        solid: "Cor Sólida",
        image: "Preenchimento com Imagem",
        gradient: "Preenchimento com Gradiente",
        contain: "Ajustar",
        repeat: "Repetir",
        cover: "Ajustar para Preencher",
        linear: "Gradiente Linear",
        radial: "Gradiente Radial",
        startColor: "Cor Inicial",
        endColor: "Cor Final",
        rotate: "Ângulo do Gradiente",
        useBackgroundToAll: "Aplicar Fundo a Todos",
      },
      elementStylePanel: {
        chartStylePanel: {
          chartDataEditor: {
            rowType: "Categoria",
            colType: "Série",
          },
          index: {
            edit: "Editar Dados do Gráfico",
            area: "Estilo do Gráfico de Área",
            line: "Estilo do Gráfico de Dispersão",
            lineSmooth: "Utilizar Linha Suave",
            horizontalBars: "Estilo do Gráfico de Barras",
            stackBars: "Estilo Empilhado",
            donut: "Estilo do Gráfico de Donut",
            img: "Legenda",
            hidden: "Ocultar",
            showTop: "Mostrar no Topo",
            showBottom: "Mostrar na Base",
            tabColor: "Cor da Grade",
            labelColor: "Cor da fonte",
            titleSetColor: "Cores do Tema:",
            title: "Temas Recomendados",
            titleColor: "Adicionar Cor do Tema",
          },
        },
        audioStylePanel: {
          imgColor: "Cor do Ícone",
          autoPlay: "Reprodução Automática",
          loopPlay: "Reprodução em Loop",
        },
        imageStylePanel: {
          cutImg: "Recortar Imagem",
          shape: "Por Forma",
          type: "Categoria",
          preview: "Visualização",
          use: "Usar",
          searchByType: "Buscar por Categoria",
          uploadAndReplace: "Enviar e Substituir Imagem",
          reSetStyle: "Redefinir Estilo",
          setBackground: "Definir como Plano de Fundo",
          clip1: "Por Proporção (Quadrado)",
          clip2: "Por Proporção (Retrato)",
          clip3: "Por Proporção (Paisagem)",
        },
        latexStylePanel: {
          edit: "Editar LaTeX",
          color: "Cor",
          bold: "Negrito",
        },
        lineStylePanel: {
          style: "Estilo da Linha",
          solid: "Linha Sólida",
          dotted: "Linha Pontilhada",
          color: "Cor da Linha",
          weight: "Espessura da Linha",
          startStyle: "Estilo de Início",
          endStyle: "Estilo de Fim",
          none: "Nenhum",
          arrow: "Seta",
          dot: "Ponto",
        },
        multiStylePanel: {
          colorPicker: "Cor de Preenchimento",
          style: "Estilo da Borda",
          solid: "Borda Sólida",
          dotted: "Borda Pontilhada",
          color: "Cor da Borda",
          weight: "Espessura da Borda",
        },
        shapeStylePanel: {
          replaceShade: "Clique para Substituir Forma",
          fill: "Preenchimento Sólido",
          gradient: "Preenchimento Gradiente",
          linear: "Gradiente Linear",
          radial: "Gradiente Radial",
        },
        tableStylePanel: {
          colFull: "Preenchimento de Célula",
          row: "Linhas",
          col: "Colunas",
          titleRow: "Linha de Título",
          totalRow: "Linha Total",
          firstCol: "Primeira Coluna",
          lastCol: "Última Coluna",
          titleColor: "Cor do Tema",
          themeTable: "Tabela de Tema",
        },
        textStylePanel: {
          urlError: "Endereço de Link Web Incorreto",
          command: "Lista com Marcadores",
          lineHeight: "Espaçamento entre Linhas",
          times: "Times",
          paragraphSpace: "Espaçamento entre Parágrafos",
          wordSpace: "Espaçamento entre Palavras",
          textIndent: "Recuo da Primeira Linha",
          textFill: "Preenchimento da Caixa de Texto",
          title: "Título",
          titleSmall: "Subtítulo",
          text: "Texto",
          textSmall: "Texto [Pequeno]",
          zs1: "Nota 1",
          zs2: "Nota 2",
        },
        videoStylePanel: {
          cover: "Capa de Pré-visualização de Vídeo",
          recover: "Redefinir Capa",
        },
      },
      elementAnimationPanel: {
        addEffects: "Adicionar Animação",
        selectAndAddEffects:
          "Selecionar Elementos no Canvas e Adicionar Animação",
        time: "Duração",
        triggerType: "Tipo de Disparo",
        initiative: "Disparo Inicial",
        sameTime: "Simultaneamente com Anterior",
        after: "Depois do Anterior",
        change: "Alterar Animação",
        in: "Entrada",
        out: "Saída",
        attention: "Ênfase",
      },
      elementPositionPanel: {
        layer: "Camada",
        align: "Alinhar",
        top: "Trazer para Frente",
        bottom: "Enviar para Trás",
        up: "Trazer para Cima",
        down: "Enviar para Baixo",
        noRixedRatio: "Desbloquear Proporção",
        fixedRatio: "Bloquear Proporção",
      },
      index: {
        style: "Estilo",
        symbol: "Símbolo",
        position: "Posição",
        animation: "Animação",
        design: "Design",
        slideAnimation: "Transições",
      },
      slideDesignPanel: {
        canvasSize: "Tamanho do Canvas",
        wideScreen1: "Widescreen 16:9",
        wideScreen2: "Widescreen 16:10",
        standard: "Padrão 4:3",
        paper: "Papel A3 / A4",
        title: "Tema Global",
        mainColor: "Cor do Tema",
        useMainToAll: "Aplicar Tema a Todos",
        preMain: "Tema Predefinido",
        text: "Texto Aa",
        use: "Aplicar",
        useToAll: "Aplicar a Todos",
      },
    },
    selectPanel: {
      select: "Selecionar",
      showAll: "Mostrar Todos",
      hideAll: "Esconder Todos",
      group: "Grupo",
    },
    redraw: {
      topLabel: "Redesenhar",
      msgTips: "Por favor, insira o conteúdo gerado",
      retext: "Redesenhar",
      cltext: "Cancelar",
      btnText: "Criar",
      reConfirm:
        "Gerar isso irá substituir a página atual e não salvará o conteúdo histórico. Tem certeza de que deseja continuar?",
      confirmBtnTxt: "Continuar",
    },
  },
  screen: {
    presenter: {
      normalView: "Visualização Normal",
      pen: "Caneta",
      laserPointer: "Apontador Laser",
      timer: "Temporizador",
      exitFullScreen: "Sair Tela Cheia",
      fullScreen: "Tela Cheia",
      endPresentation: "Finalizar Apresentação",
      speakerNotes: "Notas do Palestrante",
      speakersView: "Visão do Palestrante",
      previousPage: "Página Anterior",
      nextPage: "Próxima Página",
      firstPage: "Primeira Página",
      lastPage: "Última Página",
      brushTool: "Ferramenta de Pincel",
      noRemarks: "Sem Observações",
      lastPageTips: "Já é a última página",
      firstPageTips: "Já é a primeira página",
      autoPlay: "Iniciar apresentação automática",
    },
    writingBoard: {
      inkThickness: "Espessura da Tinta",
      eraserSize: "Tamanho do Apagador",
      eraser: "Apagador",
      clearInk: "Limpar Tinta",
      blackboard: "Quadro Negro",
      closeBrush: "Fechar Pincel",
    },
  },
  mobile: {
    index: {
      notSupport: "A versão móvel está sendo desenvolvida urgentemente.",
      toPc: "Por favor, visite o site em um PC.",
      editTips: "Por favor, edite no PC.",
    },
  },
  useCreateElement: {
    type: "Tipo {0}",
    class: "Série {0}",
  },
  components: {
    latexEditor: {
      index: {
        lateX: "Inserir Fórmula LaTeX",
        preViw: "Pré-visualização da Fórmula",
        symbol: "Símbolos Comuns",
        formula: "Fórmulas Predefinidas",
        error: "A fórmula não pode estar vazia",
      },
    },
    colorPicker: {
      recentUse: "Uso Recente",
    },
  },
  config: {
    latex: {
      gauss: "Fórmula Gaussiana",
      fourierSeries: "Série de Fourier",
      taylorExpansion: "Expansão de Taylor",
      definiteIntegral: "Integral Definida",
      trigonometricIdentity1: "Identidade Trigonométrica 1",
      trigonometricIdentity2: "Identidade Trigonométrica 2",
      expansion: "Expansão da Soma",
      euler: "Fórmula de Euler",
      differential: "Equação de Bernoulli",
      totalDifferentialEquation: "Equação Diferencial Total",
      homogeneous: "Equação Não-homogênea",
      cauchy: "Teorema do Valor Médio de Cauchy",
      lagrange: "Teorema do Valor Médio de Lagrange",
      arcsin: "Fórmula da Derivada",
      trigonometric: "Integração de Função Trigonométrica",
      quadric: "Superfície Quadrática",
      dx: "Diferencial de Segunda Ordem",
      partial: "Derivada Direcional",
      operators: "Matemática",
      group: "Combinações",
      verbatim: "Funções",
      greek: "Letras Gregas",
    },
    symbol: {
      letter: "letra",
      number: "número",
      math: "matemática",
      arrow: "seta",
      graph: "gráfico",
    },
    lines: {
      straight: "Reta",
      brokenOrCurve: "Quebrada ou Curva",
    },
  },
  hotkey: {
    opt: {
      common: "Comum",
      ctrlX: "Recortar",
      ctrlC: "Copiar",
      ctrlV: "Colar",
      ctrlD: "Copia Rápida Colar",
      ctrlA: "Selecionar Tudo",
      ctrlZ: "Desfazer",
      ctrlY: "Refazer",
      del: "Excluir",
      ctrlMore: "Seleção Múltipla",
      ctrlP: "Imprimir",
      esc: "Fechar Pop-up",
    },
    slide: {
      show: "Apresentação de Slides",
      edit: "Editar Slide",
      first: "Iniciar Apresentação de Slides do Início",
      current: "Iniciar Apresentação de Slides do Slide Atual",
      spacePre: "Alternar para Página Anterior",
      spaceNext1: "Alternar para Próxima Página",
      spaceNext2: "Alternar para Próxima Página",
      out: "Sair da Apresentação",
      new: "Novo Slide",
      move: "Mover Canvas",
      upOrDown: "Zoom no Canvas",
      up: "Zoom In no Canvas",
      down: "Zoom Out no Canvas",
      screen: "Ajustar Canvas à Tela Atual",
      noSelectPrePage: "Página Anterior (Elementos Não Selecionados)",
      noSelectNextPage: "Próxima Página (Elementos Não Selecionados)",
      prePage: "Página Anterior",
      nextPage: "Próxima Página",
    },
    element: {
      opt: "Operações de Elementos",
      move: "Mover",
      lock: "Travar",
      combo: "Agrupar",
      cancelCombo: "Desagrupar",
      top: "Trazer para Frente",
      bottom: "Enviar para Trás",
      h: "Travar Proporção",
      v: "Criar Linha Horizontal / Vertical",
      change: "Alternar Elemento Focado",
      com: "Confirmar Recorte de Imagem",
      text: "texto",
      image: "imagem",
      shape: "forma",
      line: "linha",
      chart: "gráfico",
      table: "tabela",
      video: "vídeo",
      audio: "áudio",
      latex: "Fórmula",
    },
    table: {
      edit: "Editar Tabela",
      nextCol: "Focar na Próxima Célula",
      insertTop: "Inserir Linha Acima",
      insertBottom: "Inserir Linha Abaixo",
      insertLeft: "Inserir Coluna à Esquerda",
      insertRight: "Inserir Coluna à Direita",
    },
    chat: {
      edit: "Editar Dados do Gráfico",
      nextLine: "Focar na Próxima Linha",
    },
    text: {
      edit: "Editar Texto",
      bold: "Negrito",
      italics: "Itálico",
      underline: "Sublinhado",
      delLine: "Riscar",
    },
  },
  shape: {
    rectangle: "Retângulo",
    commonUse: "Formas Comuns",
    arrow: "Seta",
    other: "Outras Formas",
    line: "Linha",
  },
  animation: {
    in: {
      bounce: "saltitar",
      bounceIn: "entrarSaltitando",
      bounceInLeft: "entrarSaltitandoEsquerda",
      bounceInRight: "entrarSaltitandoDireita",
      bounceInUp: "entrarSaltitandoCima",
      bounceInDown: "entrarSaltitandoBaixo",
      fade: "desvanecer",
      fadeIn: "aparecer",
      fadeInDown: "aparecerDeCima",
      fadeInDownBig: "aparecerDeCimaGrande",
      fadeInLeft: "aparecerDaEsquerda",
      fadeInLeftBig: "aparecerDaEsquerdaGrande",
      fadeInRight: "aparecerDaDireita",
      fadeInRightBig: "aparecerDaDireitaGrande",
      fadeInUp: "aparecerDeBaixo",
      fadeInUpBig: "aparecerDeBaixoGrande",
      fadeInTopLeft: "aparecerSuperiorEsquerda",
      fadeInTopRight: "aparecerSuperiorDireita",
      fadeInBottomLeft: "aparecerInferiorEsquerda",
      fadeInBottomRight: "aparecerInferiorDireita",
      rotate: "rotacionar",
      rotateIn: "entrarRotacionando",
      rotateInDownLeft: "entrarRotacionandoEsquerdaBaixo",
      rotateInDownRight: "entrarRotacionandoDireitaBaixo",
      rotateInUpLeft: "entrarRotacionandoEsquerdaCima",
      rotateInUpRight: "entrarRotacionandoDireitaCima",
      zoom: "zoom",
      zoomIn: "aumentar",
      zoomInDown: "aumentarDeCima",
      zoomInLeft: "aumentarDaEsquerda",
      zoomInRight: "aumentarDaDireita",
      zoomInUp: "aumentarDeBaixo",
      slide: "deslizar",
      slideInDown: "deslizarDeCima",
      slideInLeft: "deslizarDaEsquerda",
      slideInRight: "deslizarDaDireita",
      slideInUp: "deslizarDeBaixo",
      flip: "virar",
      flipInX: "virarNaHorizontal",
      flipInY: "virarNaVertical",
      back: "voltar",
      backInDown: "entrarVoltandoDeCima",
      backInLeft: "entrarVoltandoDaEsquerda",
      backInRight: "entrarVoltandoDaDireita",
      backInUp: "entrarVoltandoDeBaixo",
      lightSpeed: "velocidadeLuz",
      lightSpeedInRight: "velocidadeLuzEntrarDireita",
      lightSpeedInLeft: "velocidadeLuzEntrarEsquerda",
    },
    out: {
      bounce: "saltitar",
      bounceOut: "sairSaltitando",
      bounceOutLeft: "sairSaltitandoEsquerda",
      bounceOutRight: "sairSaltitandoDireita",
      bounceOutUp: "sairSaltitandoCima",
      bounceOutDown: "sairSaltitandoBaixo",
      fade: "desvanecer",
      fadeOut: "desaparecer",
      fadeOutDown: "desaparecerParaBaixo",
      fadeOutDownBig: "desaparecerParaBaixoGrande",
      fadeOutLeft: "desaparecerParaEsquerda",
      fadeOutLeftBig: "desaparecerParaEsquerdaGrande",
      fadeOutRight: "desaparecerParaDireita",
      fadeOutRightBig: "desaparecerParaDireitaGrande",
      fadeOutUp: "desaparecerParaCima",
      fadeOutUpBig: "desaparecerParaCimaGrande",
      fadeOutTopLeft: "desaparecerSuperiorEsquerda",
      fadeOutTopRight: "desaparecerSuperiorDireita",
      fadeOutBottomLeft: "desaparecerInferiorEsquerda",
      fadeOutBottomRight: "desaparecerInferiorDireita",
      rotate: "rotacionar",
      rotateOut: "sairRotacionando",
      rotateOutDownLeft: "sairRotacionandoEsquerdaBaixo",
      rotateOutDownRight: "sairRotacionandoDireitaBaixo",
      rotateOutUpLeft: "sairRotacionandoEsquerdaCima",
      rotateOutUpRight: "sairRotacionandoDireitaCima",
      zoom: "zoom",
      zoomOut: "diminuir",
      zoomOutDown: "diminuirParaBaixo",
      zoomOutLeft: "diminuirParaEsquerda",
      zoomOutRight: "diminuirParaDireita",
      zoomOutUp: "diminuirParaCima",
      slide: "deslizar",
      slideOutDown: "deslizarParaBaixo",
      slideOutLeft: "deslizarParaEsquerda",
      slideOutRight: "deslizarParaDireita",
      slideOutUp: "deslizarParaCima",
      flip: "virar",
      flipOutX: "virarNaHorizontal",
      flipOutY: "virarNaVertical",
      back: "voltar",
      backOutDown: "sairVoltandoParaBaixo",
      backOutLeft: "sairVoltandoParaEsquerda",
      backOutRight: "sairVoltandoParaDireita",
      backOutUp: "sairVoltandoParaCima",
      lightSpeed: "velocidadeLuz",
      lightSpeedOutRight: "velocidadeLuzSairDireita",
      lightSpeedOutLeft: "velocidadeLuzSairEsquerda",
    },
    attention: {
      shake: "tremer",
      shakeX: "tremerHorizontal",
      shakeY: "tremerVertical",
      headShake: "balançarCabeça",
      swing: "balançar",
      wobble: "oscilar",
      tada: "tada",
      jello: "gelatina",
      other: "outro",
      bounce: "saltitar",
      flash: "flash",
      pulse: "pulso",
      rubberBand: "bandaDeBorracha",
      heartBeat: "batimentoCardíaco",
    },
  },
  requestError: {
    tokenExpires: "Autenticação falhou, incapaz de acessar recursos do sistema",
    permissionDenied: "Operação atual não permitida",
    notFound: "Recurso não encontrado",
    default:
      "Erro de sistema desconhecido, por favor, reporte ao administrador",
    exceptionReminder: "Lembrete de exceção",
    pleaseLogin: "Sessão inválida ou expirada, por favor, faça login novamente",
    networkError: "Erro de rede",
    requestTimeOut: "Tempo limite de requisição de interface de sistema",
    requestFailed: "Requisição falhou",
  },
  promptsText: {
    theme: [
      "Explore diferentes temas e descubra diversão infinita!",
      "Clique em cada página de tema e embarque em uma jornada mágica!",
      "Cada tema tem seu próprio encanto único, por que não explorá-los todos?",
      "Bem-vindo ao mundo dos temas, escolha seus interesses e comece sua aventura!",
      "Seu primeiro slideshow de IA está prestes a chegar, fique ligado!",
      "Embarque em uma jornada de slides, partida iminente...",
      "Pronto para um novo festim visual? O slideshow está prestes a começar...",
      "Segure-se firme! Próxima parada, a fantástica jornada de slides...",
      "Rápido! Feche os olhos e aguarde o surpreendente slideshow chegar...",
      "O mundo do slideshow está prestes a se revelar para você, fique ligado...",
      "Por favor, seja paciente, o sonho do slideshow está prestes a se tornar realidade...",
    ],
    directory: [
      "Encontre tudo que você precisa na página do diretório!",
      "A página do diretório é o seu tesouro de navegação, facilitando encontrar o que você precisa!",
      "A página do diretório oferece serviços de navegação abrangentes, permitindo que você encontre rapidamente seus alvos!",
      "Não tem certeza para onde ir? Encontre inspiração e direção na página do diretório!",
    ],
    Content: [
      "Aguardando... o próximo slide será colorido como um arco-íris!",
      "Uau! O próximo slide vai florescer como fogos de artifício, deixando você maravilhado!",
      "Tenha paciência, o próximo slide será tão maravilhoso quanto esperar por um arco-íris dos sonhos!",
      "Sinta a magia da espera! O próximo slide vai iluminar seus olhos!",
      "Fique ligado! O próximo slide trará um festim visual surpresa!",
      "Rápido! Abra as cortinas, prepare-se para abraçar a luz deslumbrante do próximo slide!",
      "Prepare-se! O próximo slide trará uma nova tempestade visual!",
      "Sua curiosidade está prestes a ser satisfeita! O próximo slide vai surpreendê-lo!",
      "Aguardando... o próximo slide vai levá-lo a uma maravilhosa jornada visual!",
      "Não consegue esperar? O próximo slide será tão emocionante quanto uma grande celebração!",
      "Adivinhe o que será o próximo slide? A resposta está prestes a ser revelada...",
      "Por favor, aperte o cinto de segurança, estamos prestes a voar para o próximo slide...",
      "A felicidade está chegando! O próximo slide está se aproximando rapidamente...",
      "Adivinhe de que cor será o próximo slide? A resposta está prestes a ser revelada...",
      "Uau! O próximo slide vai trazer surpresas inesperadas...",
      "Ansioso para experimentar? O próximo slide vai satisfazer sua curiosidade...",
      "Aguardando... o próximo slide trará alegria e surpresas...",
      "Aguardando... assim como esperar por uma deliciosa xícara de café, o próximo slide vai alegrar seu humor!",
      "Feche os olhos, conte até três, o próximo slide vai trazer surpresas! 1... 2... 3...",
      "Em aventura! Esperar pelo próximo slide é tão emocionante quanto descobrir um tesouro!",
      "Você está pronto? O próximo slide vai levá-lo a uma maravilhosa aventura!",
    ],
    Comprehensive: [
      "Passo a passo, explore o mundo infinito de diversão!",
      "De temas para diretórios e depois para páginas de conteúdo, cada passo é uma jornada de descoberta!",
      "Vamos embarcar juntos em uma jornada maravilhosa, deixando nossas marcas neste mundo emocionante!",
      "Neste surpreendente site, vamos descobrir mais juntos!",
    ],
    Unpurchased: [
      "Ansioso para experimentar? O próximo slide vai iniciar um festim visual, junte-se a nós!",
      "Mais do que apenas produtos, é um estilo de vida! Clique para comprar e deixe seu humor voar!",
      "Aqui, você não está apenas comprando produtos, mas também comprando felicidade em abundância!",
      "Junte-se como membro e comece um novo capítulo de vida alegre!",
      "Clique para comprar e faça de cada dia cheio de surpresas e diversão!",
      "Comprar é mais do que uma ação, é uma maneira de aproveitar a vida!",
      "Aproveite a oportunidade, compre seus produtos desejados e torne a vida mais colorida!",
      "Comprar é uma aventura maravilhosa, vamos embarcar nesta jornada juntos!",
      "Clique para comprar, traga para si uma surpresa e felicidade!",
      "Comprar é uma expressão, vamos escolher com o coração juntos!",
    ],
  },
};
